import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import React from 'react';
import cookie from 'react-cookies';
import RootNavigator from './components/navigation/RootNavigator';
import { getTheme } from './components/theme/Theme';


class App extends React.Component {

    constructor(props) {
        super(props)

        const theme = getTheme(this.doChangeTheme)

        this.state = { theme }
    }

    doChangeTheme = theme => {
        cookie.save('i-theme-primary', JSON.stringify(theme.palette.primary))
        cookie.save('i-theme-secondary', JSON.stringify(theme.palette.secondary))
        this.setState({
            theme
        })
    }

    render() {
        return (
            <MuiThemeProvider theme={this.state.theme}>

                <CssBaseline />

                <RootNavigator />

            </MuiThemeProvider>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js